import React from 'react';
import { Select } from 'antd';
import { useTaskDrawer } from '../TaskDrawerContext';
import { getFullName } from '../utils/personUtils';
import Avatar from './Avatar';

export default function TaskCollaborators() {
    const { collaborators, availableEmployees, handleAddCollaborator, handleRemoveCollaborator } = useTaskDrawer();

    return (
        <section className="space-y-3 pt-4 border-t border-surface-container-high">
            <div className="flex items-center justify-between">
                <label className="font-bold text-on-surface">Collaborators</label>
                {availableEmployees.length > 0 && (
                    <Select placeholder="Add collaborator..." onChange={handleAddCollaborator} value={null} className="w-48 text-xs" showSearch optionFilterProp="label">
                        {availableEmployees.map((employee) => (
                            <Select.Option key={employee._id} value={employee._id} label={getFullName(employee)}>
                                <div className="flex items-center gap-2">
                                    <Avatar person={employee} size={18} />
                                    <span className="text-xs">{getFullName(employee)}</span>
                                </div>
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </div>
            <div className="flex flex-wrap gap-2">
                {collaborators.map((collaborator) => {
                    const name = getFullName(collaborator);
                    return (
                        <div key={collaborator._id || collaborator} className="inline-flex items-center gap-1.5 bg-[#03488a]/10 px-3 py-1 rounded-full text-xs font-medium text-[#03488a]">
                            <Avatar person={collaborator} size={16} />
                            <span className="truncate max-w-[120px]" title={name}>{name}</span>
                            <button onClick={() => handleRemoveCollaborator(collaborator._id || collaborator)} className="hover:text-error font-bold ml-1 text-sm flex items-center">x</button>
                        </div>
                    );
                })}
                {collaborators.length === 0 && <span className="text-xs text-on-surface-variant opacity-60 italic">No collaborators added yet</span>}
            </div>
        </section>
    );
}
